<!-- Modal Header -->
<div class="modal-header">
    <h5 class="modal-title" id="workshopDetailModalLabel">
        {{ workshop?.title }}
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.close()"></button>
</div>

<!-- Modal Body -->
<div class="modal-body">
    <!-- Status + Seats (register mode only) -->
    @if (mode === 'register') {
    <div class="row align-items-center mb-3">
        <div class="col-12 col-md-3">
            <span class="chip-outline" [class]="workshop ? getWorkshopStatusClass(workshop) : ''">
                {{ workshop ? getWorkshopFriendlyStatus(workshop) : '' | titlecase }}
            </span>
        </div>
        @if (workshop ? shouldShowSeats(workshop) : false) {
        <div class="col-12 col-md-6 d-flex justify-content-center justify-content-md-start mt-2 mt-md-0">
            <span class="workshop-time" [attr.aria-label]="workshop?.seatsRemaining + ' seats remaining'">
                <i class="fa-solid fa-chair material-icon-fa" aria-hidden="true"></i>&nbsp;{{ workshop?.seatsRemaining
                }} seats left
            </span>
        </div>
        }
    </div>
    }

    <!-- Cancellation Reason -->
    @if (workshop?.status?.toLowerCase() === 'canceled' && workshop?.cancellationReason) {
    <div class="alert alert-warning d-flex align-items-start gap-2 mb-3" role="alert">
        <i class="fa-solid fa-triangle-exclamation mt-1" aria-hidden="true"></i>
        <div>
            <div class="fw-semibold">This workshop has been cancelled</div>
            <div>{{ workshop?.cancellationReason }}</div>
        </div>
    </div>
    }

    <!-- Workshop Detail Rows (always visible) -->
    <div class="workshop-detail-rows">
        <div class="row workshop-detail-row">
            <div class="col-12 col-md-6">
                <div class="row workshop-detail-group">
                    <div class="col-12 col-md-4 workshop-detail-label">Start Date</div>
                    <div class="col-12 col-md-8 workshop-detail-value">{{
                        formatWorkshopDateTime(workshop!.sessionStartDateTime)}}</div>
                </div>
                <div class="row workshop-detail-group">
                    <div class="col-12 col-md-4 workshop-detail-label">End Date</div>
                    <div class="col-12 col-md-8 workshop-detail-value">{{
                        formatWorkshopDateTime(workshop!.sessionEndDateTime)}}</div>
                </div>
                @if(formatWorkshopMode(workshop!).toLowerCase() == 'online')
                {
                <div class="row workshop-detail-group">
                    <div class="col-12 col-md-4 workshop-detail-label">Video Link</div>
                    <div class="col-12 col-md-5 workshop-detail-value">
                        <div class="d-grid gap-1"  [mdbTooltip]="workshop?.isRegistered ? '' : 'Link available after registration'">
                            @if (workshop?.isRegistered) {
                            <a class="btn btn-primary" [href]="workshop?.videoLink" target="_blank"
                                rel="noopener noreferrer" aria-label="Watch workshop video (opens in new tab)">
                                <i class="fa-solid fa-video" aria-hidden="true"></i>
                            </a>
                            } @else {
                            <span class="btn btn-primary disabled" aria-disabled="true"
                                aria-label="Video link available after registration">
                                <i class="fa-solid fa-video" aria-hidden="true"></i>
                            </span>
                            }
                        </div>
                    </div>
                </div>
                }
                @else{
                <div class="row workshop-detail-group">
                    <div class="col-12 col-md-4 workshop-detail-label">Location</div>
                    <div class="col-12 col-md-8 workshop-detail-value">{{ formatWorkshopLocation(workshop!) }}</div>
                </div>
                <div class="row workshop-detail-group">
                    <div class="col-12 col-md-4 workshop-detail-label">Room</div>
                    <div class="col-12 col-md-8 workshop-detail-value">{{ workshop?.room }}</div>
                </div>
                }

            </div>
            <div class="d-none d-md-flex col-md-auto px-0">
                <div class="vr vr-blurry" style="height: auto;"></div>
            </div>
            <div class="col-12 col-md-5">
                <div class="row workshop-detail-group">
                    <div class="col-12 col-md-4 workshop-detail-label">Language</div>
                    <div class="col-12 col-md-8 workshop-detail-value">{{ workshop?.language }}</div>
                </div>
                <div class="row workshop-detail-group">
                    <div class="col-12 col-md-4 workshop-detail-label">Format</div>
                    <div class="col-12 col-md-8 workshop-detail-value">{{ formatWorkshopMode(workshop!) }}</div>
                </div>
                <div class="row workshop-detail-group">
                    <div class="col-12 col-md-4 workshop-detail-label">Topic</div>
                    <div class="col-12 col-md-8 workshop-detail-value">{{ workshop?.topic }}</div>
                </div>
            </div>
        </div>
        <div class="row workshop-detail-row">
            <div class="col-12">
                <div class="row workshop-detail-group">
                    <div class="workshop-detail-label">Description</div>
                    <div class="workshop-detail-value">{{ workshop?.description }}</div>
                </div>
            </div>
        </div>

    </div>

    <!-- Registration Confirm Section -->
    @if (mode === 'register') {
    <app-gradientsegmentbar></app-gradientsegmentbar>
    <div #confirmSection class="card p-3 alert-light" role="group" aria-labelledby="confirmSectionLabel">


        <h5 class="text-black fw-semibold mb-1" id="confirmSectionLabel">Confirm Registration</h5>

        <!-- Accommodation Needs (Optional) -->
        <div class="mb-3">
            <label for="accommodationNote" class="form-label text-black">
                Accommodation Needs (Optional)
            </label>
            <textarea id="accommodationNote" class="form-control" rows="3" [formControl]="accommodationNote"
                placeholder="Describe any accommodations you may need..." aria-describedby="accommodationHint">
            </textarea>
        </div>

        <!-- recaptcha Checkbox -->
        <div class="mb-3">
            <app-mock-recaptcha (captchaResolved)="captchaVerified.set($event)"></app-mock-recaptcha>
            @if (!captchaVerified() && submitAttempted()) {
            <div class="row">
                <div class="col-12">
                    <div id="recaptchaError" class="alert alert-warning mt-3" style="max-width:400px;"
                        aria-live="polite">
                        Please complete reCAPTCHA before confirming.
                    </div>
                </div>

            </div>
            }
        </div>

    </div>
    }

    <!-- Cancellation Confirm Section -->
    @if (mode === 'registered') {
    <app-gradientsegmentbar></app-gradientsegmentbar>

    <div #cancellationSection class="card p-3 alert-light" role="group" aria-labelledby="cancellationSectionLabel">


        <h5 class="text-black fw-semibold mb-1" id="cancellationSectionLabel">Cancel Registration</h5>

        <!-- Acknowledgment Checkbox -->
        <div class="mt-2">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" id="cancellationAck" [formControl]="cancellationAck"
                    aria-describedby="cancellationAckError" required />
                <label class="form-check-label" for="cancellationAck">
                    <span class="form-required-asterisk" aria-hidden="true">*&nbsp;</span> I want to cancel my
                    registration. I understand I can register again later if seats are available.
                </label>
            </div>
                @if (cancellationAck.invalid && cancellationAck.touched) {
      
                        <div id="recaptchaError" class="alert alert-warning mt-3" aria-live="polite"
                            style="max-width:400px;">
                            You must acknowledge the cancellation policy before proceeding.
                        </div>

                }

            <!-- recaptcha Checkbox -->
            <div class="mb-3 mt-3">
                <app-mock-recaptcha (captchaResolved)="captchaVerified.set($event)"></app-mock-recaptcha>
                @if (!captchaVerified() && submitAttempted()) {
                <div class="row">
                    <div class="col-12">
                        <div id="cancelRecaptchaError" class="alert alert-warning mt-3" style="max-width:400px;"
                            aria-live="polite">
                            Please complete reCAPTCHA before confirming.
                        </div>
                    </div>

                </div>
                }
            </div>
        </div>

    </div>
    }

</div>

<!-- Modal Footer -->
<div class="modal-footer py-1">

    @if (mode === 'register') {

    <div class="d-grid gap-2 col-10 mx-auto">
        <button type="button" class="btn btn-lg" [class.btn-primary]="firstAttemptRegister()"
            [class.btn-success]="!firstAttemptRegister()" mdbRipple (click)="submitRegistration()">
            <i class="fa-solid fa-user-plus me-2" aria-hidden="true"></i>
            {{registerButtonText()}}
        </button>
    </div>

    } @else if (mode === 'registered') {

    <div class="d-grid gap-2 col-10 mx-auto">
        <button type="button" class="btn btn-secondary btn-lg" mdbRipple (click)="submitCancellation()">
            <i class="fa-solid fa-person-walking-dashed-line-arrow-right me-2" aria-hidden="true"></i>
            Cancel Registration
        </button>
    </div>

    } @else if (mode === 'full') {

    <div class="d-grid gap-2 col-10 mx-auto">
        <button type="button" class="btn btn-dark btn-lg" disabled mdbRipple>
            <i class="fa-solid fa-ban me-2" aria-hidden="true"></i>
            No Available Seats
        </button>
    </div>

    } @else if (mode === 'cancelled') {

    <div class="d-grid gap-2 col-10 mx-auto">
        <button type="button" class="btn btn-dark btn-lg" disabled mdbRipple>
            <i class="fa-solid fa-ban me-2" aria-hidden="true"></i>
            {{ workshop ? getWorkshopFriendlyStatus(workshop) : '' | titlecase }}
        </button>
    </div>

    }

</div>